export const SESSION_API_BASE_URL = '/api/session';

export const SESSION_API_LOGOUT_URL = '/v1/logout';

export const SESSION_API_PROVIDER_URL = '/v1/provider';

export const SESSION_LOGGEDOUT_PATH = '/loggedout';
